import script from "./BriefingModal.vue?vue&type=script&setup=true&lang=js"
export * from "./BriefingModal.vue?vue&type=script&setup=true&lang=js"

import "./BriefingModal.vue?vue&type=style&index=0&id=2196a5cd&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2196a5cd"]])

export default __exports__